import RichText from "@components/RichText";
import Section from "@components/Section";
import { FC } from "react";

interface RichTextV2Props {
  data: {
    content?: string | null;
  };
}

const RichTextV2: FC<RichTextV2Props> = ({ data }) => {
  return (
    <Section section={data} className="my-[120px]">
      <RichText>{data.content}</RichText>
    </Section>
  );
};

export default RichTextV2;
